<template>
  <counter-input-desktop
    v-if="!isMobile"
    class="counter--d"
    v-bind="$props"
    @change="$emit('update', $event)"
    @addToBasket="$emit('addToBasket', $event)"
    ref="counterInputDesktop"
  />
  <counter-input-mobile
    v-else
    class="counter--m"
    v-bind="$props"
    @change="$emit('update', $event)"
    @addToBasket="$emit('addToBasket', $event)"
    ref="counterInputMobile"
  />
</template>

<script lang="ts">
  import {defineAsyncComponent, defineComponent, PropType} from 'vue';
  import Counter from '../../../bps/types/Counter';
  import {useIsMobile} from '@/bps/utilities/composables/isMobile/isMobile';

  const counterInputDesktop = defineAsyncComponent(() => import('./counterInputDesktop.vue'));
  const counterInputMobile = defineAsyncComponent(() => import('./counterInputMobile.vue'));

  export default defineComponent({
    name: 'CounterInput',
    components: {
      counterInputDesktop, counterInputMobile
    },

    props: {
      counter: {
        type: Object as PropType<Counter>,
        required: true
      },
      onlyOneItem: {
        type: Boolean as PropType<boolean>,
        default: false
      },
      disableInputEdit: {
        type: Boolean as PropType<boolean>,
        default: false
      }
    },

    emits: ['update', 'addToBasket'],

    setup() {
      const {isMobile} = useIsMobile(767);
      return {
        isMobile
      }
    },

    computed: {
      value() {
        return this.counterInput.value;
      },
      counterInput() {
        return this.isMobile ? this.$refs.counterInputMobile : this.$refs.counterInputDesktop;
      }
    },
    methods: {
      setValue(value: number) {
        this.counterInput.setValue(value);
      }
    }
  });
</script>
